<template>
  <div>
    <div class="wrap myinfo-wrap">
      <div class="top-header">
        <h3>My Info</h3>
      </div>
      <div class="body-wrap">
        <div class="con-02">
          <h1>기본정보</h1>
          <ul>
            <li>
              <h4>
                이름
                <p>{{ my_info.username }}</p>
              </h4>
            </li>
            <li>
              <h4>
                ID(이메일)
                <p>{{ my_info.userId }}</p>
              </h4>
            </li>
            <li>
              <h4>
                비밀번호
                <button @click="passwordTrans()">비밀번호 변경하기</button>
              </h4>
            </li>
            <li>
              <h4>
                앱 버전
                <p>{{ version }}</p>
              </h4>
            </li>
          </ul>
        </div>

        <button class="logout" @click="logout()">로그아웃</button>
      </div>
      <div class="menu-wrap">
        <incTab></incTab>
      </div>
    </div>
  </div>
</template>
<script>
import { App } from "@capacitor/app";
import incTab from "@/components/inc/inc_tab.vue";
export default {
  name: "myinfo",
  data: () => ({
    my_info: {},
    version: "",
  }),
  components: {
    incTab,
  },
  mounted() {
    App.getInfo().then((value) => {
      this.version = value.version;
    });
    this.getMyInfo();
  },
  methods: {
    getMyInfo() {
      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
      };
      this.axios
        .get("/auth/users", { params })
        .then((res) => {
          if (res.data.success) {
            this.my_info = res.data.contentinfo;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    passwordTrans() {
      let userIdx = btoa(this.$store.state.userInfo.userIdx);
      this.$router.push({ name: "password_trans", params: { idx: userIdx, isAccount: 0 } });
    },
    logout() {
      this.axios
        .get("/auth/user-logout")
        .then((res) => {
          if (res.data.success) {
            localStorage.clear();
            location.href = "/";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
